/**
 * @generated SignedSource<<8b1b1dc634f391e9890fcc84935afb30>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type IntegrationLinkJiraProjectsQuery$variables = {};
export type IntegrationLinkJiraProjectsQuery$data = {
  readonly viewer: {
    readonly jiraProjects: ReadonlyArray<{
      readonly id: string;
      readonly key: string;
      readonly name: string;
    }>;
  };
};
export type IntegrationLinkJiraProjectsQuery = {
  response: IntegrationLinkJiraProjectsQuery$data;
  variables: IntegrationLinkJiraProjectsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "JiraProject",
  "kind": "LinkedField",
  "name": "jiraProjects",
  "plural": true,
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "IntegrationLinkJiraProjectsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "IntegrationLinkJiraProjectsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e067e91c0a5589de0106235e9113bdec",
    "id": null,
    "metadata": {},
    "name": "IntegrationLinkJiraProjectsQuery",
    "operationKind": "query",
    "text": "query IntegrationLinkJiraProjectsQuery {\n  viewer {\n    jiraProjects {\n      id\n      name\n      key\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "1bc4641a1e6a3453f68000c2a959ae05";

export default node;
